import React from 'react';
import Tag from '../../../../../../muiComponents/Tag';
import Status from '../../../../../../components/Status';
import Tooltip from '../../../../../../muiComponents/Tooltip';
import useTranslate from '../../../../../../customHooks/useTranslate';
import useLanguage from '../../../../../../customHooks/useLanguage';
import {
    formatRelativeTime,
    formatUTCDateTime,
} from '../../../../../../utils/formatDates';
import { getCSSVariable } from '../../../../../../stylesheets/cssVariablesUtils';
import { AgencyTypeLogState } from '../../../../types/zitoneoServicesTypes';
import {
    CONNECTIVITY_LOG_TYPE_ICONS,
    CONNECTIVITY_LOG_TYPE_TAG_COLORS,
} from '../../../../utils/zitoneoServicesUtils';

interface ConnectivityLogsAgencyTypeRowProps {
    typeLog: AgencyTypeLogState;
}

const ConnectivityLogsAgencyTypeRow = ({
    typeLog,
}: ConnectivityLogsAgencyTypeRowProps) => {
    const translate = useTranslate();
    const language = useLanguage();
    const { typeKey, last, lastSuccessful } = typeLog;

    return (
        <div className='flex-column gap-5'>
            <div className='connectivity-logs-panel__row'>
                <Tag
                    text={typeKey}
                    variant='outlined'
                    startIcon={CONNECTIVITY_LOG_TYPE_ICONS[typeKey]}
                    uppercase
                    color={CONNECTIVITY_LOG_TYPE_TAG_COLORS[typeKey]}
                />
                <div className='flex-grow flex-end'>
                    <Status
                        text={translate(last.Failed ? 'failed' : 'ok')}
                        color={
                            last.Failed
                                ? getCSSVariable('error400')
                                : getCSSVariable('primary400')
                        }
                    />
                </div>
                <Tooltip title={formatUTCDateTime(last.DateCreated, language)}>
                    <span className='text-lowercase text-grey-600 text-italic'>
                        {formatRelativeTime(last.DateCreated, language)}
                    </span>
                </Tooltip>
            </div>
            {last.Failed && lastSuccessful && (
                <div className='connectivity-logs-panel__row connectivity-logs-panel__row--secondary'>
                    <span />
                    <span>{`${translate('last_successful_connection')}:`}</span>
                    <Tooltip
                        title={formatUTCDateTime(
                            lastSuccessful.DateCreated,
                            language
                        )}
                    >
                        <span>
                            {formatRelativeTime(
                                lastSuccessful.DateCreated,
                                language
                            )}
                        </span>
                    </Tooltip>
                </div>
            )}
        </div>
    );
};

export default ConnectivityLogsAgencyTypeRow;
